import { render, staticRenderFns } from "./todoDetailsInvitation.vue?vue&type=template&id=b22b32d6&"
import script from "./todoDetailsInvitation.vue?vue&type=script&lang=js&"
export * from "./todoDetailsInvitation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports